var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center w-full h-full"},[_c('loading-spinner',{staticClass:"w-16 h-16"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }